var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-filter-editor"},[_c('FilterEditor',_vm._b({model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}},'FilterEditor',_vm.subObjectBinds,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }